module.exports = __webpack_public_path__ + "cg.svg?51ec77aa7dc9bd203501805508836662";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/cg.svg
// module id = 1037
// module chunks = 0